import type { ReploShopifyProduct } from "replo-runtime/shared/types";

export default function isLoadingProduct(product: ReploShopifyProduct) {
  return product?.handle === "loading-product";
}
